export default "__VITE_ASSET__DIj8tBkg__"